import { n as D, C as R, c as $, a as h } from "./article-srUBAy2r.mjs";
import { s as a } from "./styled-egLbU9Lr.mjs";
import { jsxs as m, jsx as f } from "react/jsx-runtime";
import { Box as b } from "@mui/system";
import x, { useImperativeHandle as P, useEffect as W } from "react";
import { cssToken as t } from "./utils.mjs";
import { C as B } from "./cssTokens-C6UiAxBc.mjs";
const Y = a("em", { name: D, slot: "Accent" })({
  fontStyle: "normal",
  color: R.accentColor()
}), G = a(b, { name: "Collapse", slot: "root" })({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  flex: "1 1 0"
}), E = a(b, { name: "Collapse", slot: "container" })({
  flex: "1 1 0"
}), Z = ({ open: e, header: r, footer: n, children: s, ...p }) => /* @__PURE__ */ m(G, { ...p, children: [
  r,
  /* @__PURE__ */ f(E, { sx: { overflow: e ? "visible" : "hidden" }, children: s }),
  n
] }), _ = a("img")({ border: 0, display: "block", color: "transparent" }), F = a("div", { name: $, slot: "root" })({
  [`@property ${h.offset}`]: {
    syntax: '"<length>"',
    initialValue: "0px"
  },
  width: `calc(100% - ${h.offset()} - ${h.offset()})`,
  maxWidth: h.width(),
  paddingInline: h.offset(),
  marginInline: "auto",
  boxSizing: "content-box",
  containerName: "content",
  containerType: "inline-size"
});
F.displayName = $;
const S = "Details", z = a("details", { name: S })({
  "& > summary": {
    display: "flex",
    flexFlow: "row nowrap"
  },
  "& > summary::-webkit-details-marker": {
    display: "none"
  },
  "& > summary::marker": {
    display: "none"
  }
}), ee = ({ open: e = !1, children: r, summary: n, marker: s, renderMarker: p = () => null, ...c }) => {
  const [i, u] = x.useState(e);
  return /* @__PURE__ */ m(
    z,
    {
      open: i || e,
      onToggle: (d) => {
        u(d.currentTarget.open);
      },
      ...c,
      children: [
        /* @__PURE__ */ m("summary", { children: [
          n,
          /* @__PURE__ */ m("span", { className: "Details-Marker", children: [
            s,
            p(i)
          ] })
        ] }),
        r
      ]
    }
  );
}, I = (e, r) => {
  e.style.width = r.width + "px", e.style.height = r.height + "px";
}, L = (e) => e.height / e.width, v = (e, r) => {
  const n = r.width || e.width, s = n * L(e);
  return { width: n, height: s };
}, y = "VideoPlayer", oe = {
  stageColor: t(y, ["stage", "color"])
}, V = a(b, { name: y })({
  display: "flex",
  alignItems: "center"
}), j = a("video", { name: y, slot: "Video" })({
  display: "block",
  width: "100%",
  height: "100%",
  objectFit: "cover"
}), N = x.forwardRef(({ sx: e, controlsList: r, CustomControlrs: n, ...s }, p) => {
  const c = x.useRef(null), i = x.useRef(null), u = (r || "").split(" ");
  return P(p, () => ({
    play() {
      return i.current ? i.current.play() : Promise.reject(new Error("Player not ready"));
    },
    pause() {
      return i.current ? Promise.resolve(i.current.pause()) : Promise.reject(new Error("Player not ready"));
    }
  })), W(() => {
    const d = new AbortController(), k = () => {
      const T = c.current, C = i.current;
      !C || !T || I(C, v({ width: C.videoWidth, height: C.videoHeight }, { width: T.offsetWidth }));
    };
    return document.addEventListener("fullscreenchange", k, { signal: d.signal }), window.addEventListener("resize", k, { signal: d.signal }), () => {
      d.abort();
    };
  }, []), /* @__PURE__ */ f(V, { ref: c, sx: e, children: /* @__PURE__ */ m(b, { sx: { position: "relative" }, children: [
    /* @__PURE__ */ f(
      j,
      {
        controlsList: r,
        disableRemotePlayback: u.includes("noremoteplayback"),
        onLoadedMetadata: (d) => {
          c.current && I(
            d.currentTarget,
            v(
              {
                width: d.currentTarget.videoWidth,
                height: d.currentTarget.videoHeight
              },
              { width: c.current.offsetWidth }
            )
          );
        },
        playsInline: u.includes("nofullscreen"),
        ref: i,
        "x-webkit-airplay": u.includes("noremoteplayback") ? "deny" : "allow",
        ...s
      }
    ),
    n && /* @__PURE__ */ f(n, { videoPlayer: i })
  ] }) });
});
N.displayName = y;
const l = "Input", o = {
  Gap: t(l, "gap"),
  ColorBackground: t(l, ["color", "bg"]),
  ColorText: t(l, ["color", "text"]),
  ColorTextPlaceholder: t(l, ["color", "text", "placeholder"]),
  ColorBorder: t(l, ["color", "border"]),
  ColorBorderFocus: t(l, ["color", "border", "focused"]),
  DimensionRadius: t(l, ["dimension", "radius"]),
  ColorTextDisabled: t(l, ["color", "disabled"]),
  ColorBorderDisabled: t(l, ["color", "border", "disabled"]),
  ColorBackgroundDisabled: t(l, ["color", "bg", "disabled"])
}, H = a("span", { name: l })({
  display: "inline-flex",
  alignItems: "center",
  gap: o.Gap(),
  paddingInlineStart: o.Gap(),
  paddingInlineEnd: o.Gap(),
  borderColor: o.ColorBorder(),
  borderRadius: o.DimensionRadius(),
  backgroundColor: o.ColorBackground(),
  color: o.ColorText(B.color.text.default()),
  borderWidth: "1px",
  borderStyle: "solid",
  lineHeight: 1,
  flexGrow: 1,
  boxSizing: "border-box",
  maxWidth: "100%",
  "&:hover, &:focus-within": {
    borderColor: o.ColorBorderFocus(o.ColorBorder())
  },
  "&:has(:disabled)": {
    backgroundColor: o.ColorBackgroundDisabled(o.ColorBackground()),
    color: o.ColorTextDisabled(o.ColorText(B.color.text.default())),
    borderColor: o.ColorBorderDisabled(o.ColorBorder())
  }
}), A = a("input", { name: l, slot: "Control" })({
  color: "inherit",
  backgroundColor: "transparent",
  outline: "none",
  borderWidth: 0,
  padding: 0,
  paddingBlock: o.Gap(),
  paddingInlineStart: o.Gap(),
  fontSize: "1em",
  flex: "1 1 0",
  "&::placeholder": {
    color: o.ColorTextPlaceholder(`hsl(from ${o.ColorText()} h s calc(l + 20))`)
  }
}), re = ({ Control: e = A, controlRef: r, startAdornment: n, endAdornment: s, sx: p, ...c }) => /* @__PURE__ */ m(H, { sx: p, children: [
  n,
  /* @__PURE__ */ f(e, { ref: r, ...c }),
  s
] }), g = "Field", w = {
  LabelColor: t(g, ["color", "lbl"]),
  Gap: t(g, ["dimension", "gap"]),
  BaseWidth: t(g, ["width"])
}, te = a(b, { name: g })({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  flexBasis: w.BaseWidth("auto"),
  gap: w.Gap()
}), ne = a("label", { name: g, slot: "label" })({
  color: w.LabelColor()
}), M = Intl.NumberFormat("ru-ru"), le = ({ numberFormat: e = M, value: r, currency: n = "₽", ...s }) => /* @__PURE__ */ m("span", { ...s, children: [
  e.format(r),
  " ",
  n
] });
export {
  Z as C,
  ee as D,
  te as F,
  _ as I,
  ne as L,
  le as P,
  Y as T,
  N as V,
  F as a,
  oe as b,
  o as c,
  re as d,
  w as e
};
